import { useState, useRef, FormEvent } from 'react';

export default function NewsletterSection() {
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');
  const formRef = useRef<HTMLFormElement>(null);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = formRef.current;
    if (!form) return;

    const formData = new FormData(form);
    const honeypot = formData.get('website_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      setStatus('success');
      setMessage('订阅成功！感谢您的关注。');
      return;
    }

    try {
      const res = await fetch('https://readdy.ai/api/form/d9oov6iftmtnfcfh0bg0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try { parsed = JSON.parse(text); } catch { parsed = null; }

      if (res.ok && parsed && (parsed as Record<string, string>).code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！感谢您的关注，我们将为您推送最新漫画更新。');
        form.reset();
      } else {
        const errMsg =
          (parsed as Record<string, Record<string, string>>)?.meta?.message ||
          (parsed as Record<string, string>)?.message ||
          '订阅失败，请稍后重试';
        setStatus('error');
        setMessage(errMsg);
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查连接后重试');
    }
  };

  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="bg-background-100/70 border border-background-200/70 rounded-xl p-8 md:p-10 text-center">
        <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100">
          <i className="ri-mail-send-line text-2xl text-primary-500"></i>
        </div>
        <h2 className="text-lg font-heading font-bold text-foreground-900 mb-2">
          订阅更新通知
        </h2>
        <p className="text-sm text-foreground-500 mb-6 max-w-md mx-auto">
          订阅后您将第一时间收到最新漫画更新通知，不错过任何好看的漫画！
        </p>
        <form
          ref={formRef}
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row items-center gap-3 max-w-lg mx-auto"
          data-readdy-form
        >
          <input
            type="email"
            name="email"
            placeholder="请输入您的邮箱地址"
            required
            className="flex-1 w-full px-4 py-3 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
          />
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="honeypot-field"
          />
          <button
            type="submit"
            className="px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap w-full sm:w-auto"
          >
            立即订阅
          </button>
        </form>
        {status !== 'idle' && (
          <p
            className={`mt-3 text-xs ${
              status === 'success' ? 'text-secondary-600' : 'text-primary-600'
            }`}
          >
            {message}
          </p>
        )}
      </div>
    </section>
  );
}